import styled from "styled-components";

export const SwitchRightLabel = styled.label`
	margin: 0 0 0 -30px;
	z-index: 1;
	&.active {
		z-index: 2;
	}
`;
